import React, { useState, useEffect } from "react";
import "./Login.css";
import logo from "../../assets/Logo.png";
import loginImage from "../../assets/LoginImage.jpg";
import api from "../../services/api";
import SHA256 from "crypto-js/sha256";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [lembrar, setLembrar] = useState(false);
  const [loading, setLoading] = useState(false);

  // --- STATES PARA INSTALL POPUP ---
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPopup, setShowInstallPopup] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  // --- Detecta iOS e standalone ---
  useEffect(() => {
    const ua = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipad|ipod/.test(ua);
    const standalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;

    setIsIos(ios);
    setIsStandalone(standalone);

    if (ios && !standalone) {
      setShowInstallPopup(true); // mostra popup com instruções
    }
  }, []);

  // --- Captura evento beforeinstallprompt (Android/Chrome) ---
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPopup(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  // --- Função para confirmar instalação (Android) ---
  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log("Usuário escolheu:", outcome);
      setDeferredPrompt(null);
      setShowInstallPopup(false);
    }
  };

  // --- Função de login ---
  const login = async (emailParam, senhaHashParam, lembrarMe = false) => {
    try {
      setLoading(true);
      const { data } = await api.post("/auth", {
        email: emailParam,
        senha: senhaHashParam,
      });

      if (data.error) {
        setMensagem(data.message);
        return false;
        
      } else {
        setMensagem("Login realizado com sucesso!");

        // Salva usuário e token
        localStorage.setItem(
          "usuario",
          JSON.stringify(data.usuario || data.funcionario)
        );
        localStorage.setItem("token", data.token);

        // Expira token em 8h
        const expiraEm = Date.now() + 8 * 60 * 60 * 1000;
        localStorage.setItem("tokenData", JSON.stringify({ expiraEm }));

        // Se lembrar, salva credenciais
        if (lembrarMe) {
          localStorage.setItem(
            "usuarioLembrado",
            JSON.stringify({
              email: emailParam,
              senhaHash: senhaHashParam,
            })
          );
        }

        return data;
      }
    } catch (err) {
      console.error(err);
      setMensagem("Erro ao conectar com o servidor.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // --- Tenta login automático ---
  useEffect(() => {
    const token = localStorage.getItem("token");
    const tokenData = JSON.parse(localStorage.getItem("tokenData") || "{}");
    const usuarioLembrado = JSON.parse(
      localStorage.getItem("usuarioLembrado") || "{}"
    );

    if (/*token && tokenData.expiraEm && Date.now() < tokenData.expiraEm*/ false) {
      navigate("/area-restrita");
    } else if (usuarioLembrado.email && usuarioLembrado.senhaHash) {
        login(usuarioLembrado.email, usuarioLembrado.senhaHash, true)
          .then((res) => {
            if (!res) {
              // Login falhou, limpa dados
              localStorage.removeItem("usuarioLembrado");
              localStorage.removeItem("usuarioTipo");
              return;
            }

            if (res.usuario) {
              localStorage.setItem("usuarioTipo", "cliente");
              navigate("/area-restrita");
            } else if (res.funcionario) {
              localStorage.setItem("usuarioTipo", "colaborador");
              navigate("/area-restrita/colaborador");
            }
          })
          .catch((err) => {
            // Em caso de erro na requisição, limpa dados
            console.error("Erro ao tentar login automático:", err);
            localStorage.removeItem("usuarioLembrado");
            localStorage.removeItem("usuarioTipo");
          });
        }
  }, []);

  // --- Submit formulário ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    const senhaHash = SHA256(senha).toString();
    const res = await login(email, senhaHash, lembrar);

    if (res) {
      if (res.usuario) { 
        localStorage.setItem("usuarioTipo", "cliente");
        navigate("/area-restrita");
      } else if (res.funcionario) {
        localStorage.setItem("usuarioTipo", "colaborador");
        navigate("/area-restrita/colaborador");
      }
    }
  };

  return (
    <>{/* POPUP SOBREPOSTO */}
     {false /*showInstallPopup*/ && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl shadow-lg w-11/12 max-w-md p-6 text-center">
      <h3 className="text-xl font-semibold mb-3">📲 Adicione à Tela Inicial</h3>

      {isIos ? (
        <p className="text-gray-700 mb-4">
          No iPhone, toque em{" "}
          <span className="flex items-center gap-1 font-semibold inline-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 12V4m0 0l-3 3m3-3l3 3"
              />
            </svg>
            Compartilhar
          </span>{" "}
          e selecione <strong>"Adicionar à Tela de Início"</strong>.
        </p>
      ) : (
        <p className="text-gray-700 mb-4">
          Instale este app para ter acesso rápido direto do seu celular.
        </p>
      )}

      <div className="flex justify-center gap-3">
        <button
          className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition"
          onClick={() => setShowInstallPopup(false)}
        >
          Agora não
        </button>

        {!isIos && (
          <button
            className="px-4 py-2 bg-[#003D42] text-white rounded-lg hover:bg-[#002f33] transition"
            onClick={handleInstall}
          >
            Adicionar
          </button>
        )}
      </div>
    </div>
  </div>
)}



    <div className="login-container">
      {/* Seção Esquerda */}
      <div className="login-image-section">
        <img
          src={loginImage}
          alt="Login Illustration"
          className="login-image"
        />
      </div>

      {/* Seção Direita */}
      <div className="login-form-section">
        <img className="logo" src={logo} height={100} alt="Logo" />
        <h2>Bem-vindo de volta!</h2>
        <p>Por favor, entre na sua conta</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Digite sua senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </div>
          <div className="form-options">
            <label>
              <input
                type="checkbox"
                checked={lembrar}
                onChange={(e) => setLembrar(e.target.checked)}
              />
              Lembrar de mim
            </label>
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
        {mensagem && <p className="!text-red-500">{mensagem}</p>}
      </div>
    </div>
    </>
  );
}

export default Login;
